import { type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ButtonV2 } from "@/components/atoms/Button";
import { ErrorScreen } from "@/components/organisms/ErrorScreen/ErrorScreen";

// ponytail: kept dependency-free of PageLayout on purpose — routes nested
// under plantDetailRoute import NestedRouteErrorComponent (which renders this),
// and plantDetailRoute's own layout chain (PageLayout -> Sidebar -> Home ->
// PlantSidebar) imports those routes back, so pulling PageLayout in here would
// close an ESM import cycle and throw a TDZ ReferenceError at load time.
export const ErrorFallback = ({ error, reset }: ErrorComponentProps) => {
  const { t } = useTranslation();
  const router = useRouter();

  // eslint-disable-next-line no-console -- Error logging is intentional here
  console.error("[RouteError] Route error:", error);

  const handleReset = () => {
    reset();
    void router.invalidate();
  };

  return (
    <ErrorScreen
      title={t("common.errorBoundary.title")}
      description={t("common.errorBoundary.description")}
      action={
        <ButtonV2 onClick={handleReset}>
          {t("common.errorBoundary.tryAgain")}
        </ButtonV2>
      }
    />
  );
};
